var DEFAULT_TIMEOUT = 5000;

function inlineTimeoutFrom(option) {
  return option || DEFAULT_TIMEOUT;
}

module.exports = inlineTimeoutFrom;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/options/inline-timeout.js
// module id = 2201
// module chunks = 16